import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import MapView from '../views/MapView.vue'
import LifeView from '../views/LifeView.vue'
import SocialView from '../views/SocialView.vue'
import MaterialsView from '../views/MaterialsView.vue'
import ItemView from '../views/ItemView.vue'
import ItemViewDark from '../views/ItemViewDark.vue'
import AdminView from '../views/AdminView.vue'
import TermsView from '../views/TermsView.vue'
import PrivacyView from '../views/PrivacyView.vue'
import NotFoundView from '../views/NotFoundView.vue'
import AboutView from '../views/AboutView.vue'

const routes = [
  { path: '/', name: 'home', component: HomeView },
  { path: '/map', name: 'map', component: MapView },
  { path: '/life', name: 'life', component: LifeView },
  { path: '/social', name: 'social', component: SocialView },
  { path: '/materials', name: 'materials', component: MaterialsView },
  { path: '/items/:id', name: 'item', component: ItemView, props: true },
  { path: '/items/:id/dark', name: 'item-dark', component: ItemViewDark, props: true },
  { path: '/admin', name: 'admin', component: AdminView },
  { path: '/terms', name: 'terms', component: TermsView },
  { path: '/privacy', name: 'privacy', component: PrivacyView },
  { path: '/about', name: 'about', component: AboutView },
  { path: '/:pathMatch(.*)*', name: 'not-found', component: NotFoundView },
]

const router = createRouter({
  history: createWebHistory(),
  routes,

  scrollBehavior(to, from, savedPosition) {
    // Если есть сохраненная позиция (при нажатии кнопок "назад/вперед" в браузере),
    // то возвращаемся к ней.
    if (savedPosition) {
      return savedPosition
    } 
    // В противном случае, при каждом переходе, всегда прокручиваем страницу наверх.
    else {
      return { top: 0 }
    }
  }
})

export default router
